/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import clsx from '@proton/utils/clsx';

import { MIME_ICON_VIEWBOX, type MimeIconComponentProps, getMimeIconAsset } from '../component';

export const MimeSound = ({ alt, title, size = 4, className, ...rest }: MimeIconComponentProps) => {
    const asset = getMimeIconAsset(size);

    return (
        <>
            <svg
                role="img"
                viewBox={MIME_ICON_VIEWBOX[asset]}
                focusable="false"
                className={clsx(`icon-size-${size}`, className)}
                {...rest}
            >
                {title ? <title>{title}</title> : null}
                {asset === 'sm' && (
                    <g>
                        <rect width="16" height="16" rx="2" fill="#DADBE0"></rect>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.71261 11.1844C7.82931 11.2757 7.9999 11.1926 7.9999 11.0444V5.17811C7.9999 5.02995 7.82931 4.9468 7.71261 5.03807L5.47476 6.78816V6.78818H4.17778C4.07959 6.78818 4 6.86777 4 6.96596V9.25659C4 9.35478 4.07959 9.43437 4.17778 9.43437H5.47478L7.71261 11.1844Z"
                            fill="#3A3F4A"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.4655 8.11552C11.4655 6.68562 10.309 5.53524 8.88885 5.53524V5C10.6031 5 12 6.38893 12 8.11552C12 9.84319 10.602 11.2222 8.88885 11.2222V10.687C10.3101 10.687 11.4655 9.54434 11.4655 8.11552Z"
                            fill="#3A3F4A"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.0435 8.11111C10.0435 7.47498 9.52802 6.95919 8.88879 6.95919V6.42395C9.82164 6.42395 10.578 7.17781 10.578 8.11111C10.578 9.04225 9.82379 9.80709 8.88879 9.80709V9.27185C9.52587 9.27185 10.0435 8.7494 10.0435 8.11111Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'md' && (
                    <g>
                        <path
                            d="M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V21.5C24 22.8807 22.8807 24 21.5 24H2.5C1.11929 24 0 22.8807 0 21.5V2.5Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.569 16.6102C11.7441 16.7471 12 16.6223 12 16.4001V7.60066C12 7.37842 11.7441 7.2537 11.569 7.3906L8.21224 10.0157V10.0157H6.26667C6.11939 10.0157 6 10.1351 6 10.2824V13.7184C6 13.8656 6.11939 13.985 6.26667 13.985H8.21224L11.569 16.6102Z"
                            fill="#3A3F4A"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M17.1982 12.0068C17.1982 9.86192 15.4635 8.13636 13.3333 8.13636V7.3335C15.9047 7.3335 18 9.41689 18 12.0068C18 14.5983 15.9031 16.6668 13.3333 16.6668V15.864C15.4652 15.864 17.1982 14.15 17.1982 12.0068Z"
                            fill="#3A3F4A"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.0654 12.0001C15.0654 11.0459 14.2922 10.2722 13.3334 10.2722V9.46936C14.7326 9.46936 15.8671 10.6002 15.8671 12.0001C15.8671 13.3968 14.7359 14.5441 13.3334 14.5441V13.7412C14.289 13.7412 15.0654 12.9575 15.0654 12.0001Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'lg' && (
                    <g>
                        <path
                            d="M3.39001 7.82496C3.39001 4.03076 6.46582 0.954956 10.26 0.954956H27.9481C29.7183 0.954956 31.4202 1.63829 32.6989 2.86247L42.4909 12.2368C43.8445 13.5327 44.61 15.3253 44.61 17.1993V42.175C44.61 45.9692 41.5342 49.045 37.74 49.045H10.26C6.46582 49.045 3.39001 45.9692 3.39001 42.175V7.82496Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            d="M44.4742 15.84H35.45C32.2881 15.84 29.725 13.2768 29.725 10.115V1.18872C30.8322 1.48522 31.8572 2.05667 32.6989 2.86246L42.4908 12.2368C43.5121 13.2146 44.1987 14.4751 44.4742 15.84Z"
                            fill="#EBECF0"
                        ></path>
                        <path
                            d="M44.61 17.5574H35.45C31.3396 17.5574 28.0075 14.2253 28.0075 10.1149V0.9552C28.5922 0.960253 29.169 1.03981 29.725 1.18871V10.1149C29.725 13.2768 32.2882 15.8399 35.45 15.8399H44.4742C44.5639 16.2841 44.61 16.7392 44.61 17.1993V17.5574Z"
                            fill="#BABBC5"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M23.3536 35.915C23.6162 36.1204 24 35.9333 24 35.5999V22.4007C24 22.0674 23.6162 21.8803 23.3536 22.0857L18.3185 26.0234H15.4C15.1791 26.0234 15 26.2024 15 26.4234V31.5773C15 31.7982 15.1791 31.9773 15.4 31.9773H18.3185V31.9773L23.3536 35.915Z"
                            fill="#3A3F4A"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M31.7974 29.0099C31.7974 25.7926 29.1953 23.2043 26 23.2043V22C29.8571 22 33 25.1251 33 29.0099C33 32.8972 29.8546 36 26 36V34.7957C29.1978 34.7957 31.7974 32.2248 31.7974 29.0099Z"
                            fill="#3A3F4A"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M28.598 29C28.598 27.5687 27.4383 26.4082 26 26.4082V25.2039C28.0989 25.2039 29.8006 26.9 29.8006 29C29.8006 31.095 28.1038 32.8159 26 32.8159V31.6116C27.4334 31.6116 28.598 30.4361 28.598 29Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
